// extracted by mini-css-extract-plugin
export default {"container":"FormContainer_container__3lqSw","title":"FormContainer_title__KJv-m","subtitle":"FormContainer_subtitle__GzJMj","form":"FormContainer_form__XnGWD"};